// CRM 2.0 "Filter by" (M1-F11, rows M1.27 / M1.41) — as prototype c2fdraw: a "Select"
// button opens a panel with the categories on the left and, on the right, the values
// found in the tab's cards (tick to filter) or, for Date, a start and end date.
// The chosen values show as chips under the bar with "Clear all" (Crm2Page).
//   cats       { name: card => value }
//   dateLabel  shown above the Date fields; no Date category when empty (Cancellations)
import React, { useEffect, useRef, useState } from "react";
import css from "./Crm2Cards.module.css";

const panelSx = {
  position: "absolute",
  top: "calc(100% + .6rem)",
  left: 0,
  zIndex: 20,
  display: "grid",
  gridTemplateColumns: "18rem 26rem",
  background: "#fff",
  border: "1px solid #EAECF0",
  borderRadius: ".8rem",
  boxShadow: "0 12px 16px -4px rgba(16,24,40,.08)",
  overflow: "hidden",
};
const catBtn = (on) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  border: 0,
  background: on ? "#EFF8FF" : "none",
  color: on ? "#1570EF" : "#344054",
  padding: "1rem 1.6rem",
  fontSize: "1.4rem",
  cursor: "pointer",
  textAlign: "left",
});
const inputSx = { width: "100%", height: "3.6rem", border: "1px solid #D0D5DD", borderRadius: ".8rem", padding: "0 1rem", fontSize: "1.4rem", marginBottom: "1rem" };

export default function FilterBy({ cats, cards, sel, setSel, date, setDate, dateLabel }) {
  const [open, setOpen] = useState(false);
  const names = dateLabel ? ["Date", ...Object.keys(cats)] : Object.keys(cats);
  const [cat, setCat] = useState(names[0]);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);
  useEffect(() => {
    if (!names.includes(cat)) setCat(names[0]);
  }, [cats]);

  const chosen = sel[cat] || [];
  const values = cat === "Date" ? [] : [...new Set((cards || []).map((c) => cats[cat]?.(c)).filter((v) => v !== undefined && v !== null && v !== ""))].sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }));
  const toggle = (v, on) => setSel((s) => ({ ...s, [cat]: on ? [...(s[cat] || []), v] : (s[cat] || []).filter((x) => x !== v) }));

  return (
    <div className={css.row} style={{ gap: "1rem", position: "relative", flexWrap: "nowrap" }} ref={ref}>
      <p className={css.flab}>Filter by</p>
      <button type="button" className={css.ddbtn} onClick={() => setOpen((o) => !o)} aria-haspopup="true" aria-expanded={open}>
        Select <span aria-hidden="true">▾</span>
      </button>
      {open && (
        <div style={panelSx}>
          <div style={{ borderRight: "1px solid #EAECF0", padding: ".6rem 0" }}>
            {names.map((k) => {
              const n = k === "Date" ? (date.from || date.to ? 1 : 0) : (sel[k] || []).length;
              return (
                <button key={k} type="button" style={catBtn(k === cat)} onClick={() => setCat(k)}>
                  {k}
                  {n > 0 && <span className={css.mchip} style={{ padding: "0 .6rem" }}>{n}</span>}
                </button>
              );
            })}
          </div>
          <div style={{ padding: "1rem 1.4rem", maxHeight: "30rem", overflow: "auto" }}>
            <p className={css.note} style={{ padding: 0, marginBottom: ".8rem" }}>{cat === "Date" ? dateLabel : cat}</p>
            {cat === "Date" ? (
              <>
                <label style={{ fontSize: "1.4rem", color: "#344054" }}>Start Date</label>
                <input type="date" style={inputSx} value={date.from} onChange={(e) => setDate((d) => ({ ...d, from: e.target.value }))} />
                <label style={{ fontSize: "1.4rem", color: "#344054" }}>End Date</label>
                <input
                  type="date"
                  style={inputSx}
                  value={date.to}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (date.from && v && v < date.from) {
                      console.warn("[crm2][FilterBy] end date before start date", { from: date.from, to: v });
                      return;
                    }
                    setDate((d) => ({ ...d, to: v }));
                  }}
                />
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <button type="button" className={css.clearAll} onClick={() => setDate({ from: "", to: "" })}>Clear</button>
                </div>
              </>
            ) : values.length ? (
              values.map((v) => (
                <label key={v} style={{ display: "flex", gap: ".8rem", alignItems: "center", marginBottom: "1rem", fontSize: "1.4rem", color: "#344054", cursor: "pointer" }}>
                  <input type="checkbox" checked={chosen.includes(v)} onChange={(e) => toggle(v, e.target.checked)} /> {v}
                </label>
              ))
            ) : (
              <p className={css.hint}>Nothing to filter in this tab</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
